import { jsx as t } from "react/jsx-runtime";
import { IconButton as l } from "../../atoms/Button/Button.es.js";
import { useMultiStyleConfig as n, chakra as i } from "@chakra-ui/react";
import { CloseIcon as r } from "../../icons/index.es.js";
const p = ({
  onClose: s,
  ...e
}) => {
  const o = n("FloatingBottomMultiselectActions");
  return /* @__PURE__ */ t(i.div, { sx: o.closeButton, children: /* @__PURE__ */ t(
    l,
    {
      "aria-label": "Close",
      variant: "transparent",
      icon: /* @__PURE__ */ t(r, { sx: o.closeIcon }),
      size: "md",
      onClick: s,
      sx: o.closeButton,
      ...e
    }
  ) });
};
export {
  p as FloatingBottomMultiselectClose
};
//# sourceMappingURL=FloatingBottomMultiselectClose.es.js.map
